const FETCH_ENTITY_GROUPS_SUCCESS = 'FETCH_ENTITY_GROUPS_SUCCESS';
const SELECT_ENTITY_GROUP_CRUD = 'SELECT_ENTITY_GROUP_CRUD';
const SET_SELECTED_ENTITY_GROUP_FIELD = 'SET_SELECTED_ENTITY_GROUP_FIELD';

export {
  FETCH_ENTITY_GROUPS_SUCCESS,
  SET_SELECTED_ENTITY_GROUP_FIELD,
  SELECT_ENTITY_GROUP_CRUD,
}
